import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import BaseLink from './BaseLink.vue';
export default {
  name: 'Button',
  components: {
    BaseLink: BaseLink
  },
  props: {
    type: {
      type: String,
      default: 'button_primary',
      validator: function validator(value) {
        return ['text', 'button_primary'].includes(value);
      }
    },
    link: {
      type: [Object, String],
      default: ''
    },
    target: {
      type: String,
      default: '_blank'
    },
    appearance: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md'
    },
    fit: {
      // Full for full-width, auto for responsive, static for same auto width
      type: String,
      default: 'full',
      validator: function validator(value) {
        return ['full', 'auto', 'static'].includes(value);
      }
    },
    buttonType: {
      type: String,
      default: 'button'
    },
    textColor: {
      type: String,
      default: 'dark'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: ''
    },
    loadingLabel: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};